import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

import Footer from './Common_Components/Footer'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useState, useEffect, useContext } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { ProductContext } from "../context/AppContext";

const QWantTry = () => {
    const [activePage, setActivePage] = useState("Learning");
    const location = useLocation();
    const navigate = useNavigate();
    const QuizData = location.state;
    const category_id = QuizData?.category_id;
    const level_id = QuizData?.level_id;
    const status = QuizData?.status;
    console.log("Quiz id and Quiz Name :", category_id, level_id, status);
    // const { category_id, status, quizTypeId, quizName, level_id } = route.params;
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const authToken = localStorage.getItem("AuthToken");
    // console.log("this is quizTypeId check ", quizTypeId )
    // console.log(status, "Ashish check status");
    const { Translate } = useContext(ProductContext);

    const categoryID = category_id;

    // console.log("this is my category ", categoryID)

    // navigation.navigate('StatusScreen', {
    //   quizTypeId: quizTypeId,
    //   quizName: quizName,
    // });

    const getStatus = (status) => {
        switch (status) {
            case 'confirm':
                return Translate?.message?.data?.Questionsdontwanttoretry || "Questions don’t want to retry";
            case 'correct':
                return Translate?.message?.data?.Questionsansweredcorrectly || "Questions answered correctly";
            case 're_attempt':
                return Translate?.message?.data?.Questionswanttoretry || "Questions want to retry";
            case 'incorrect':
                return Translate?.message?.data?.Questionsansweredwrong || "Questions answered wrong";
            case 'un_attempt':
                return Translate?.message?.data?.SkippedQuestions || "Skipped Questions";
            default:
                return "Status not recognized"; // Optional default case
        }
    }
    useEffect(() => {

        const fetchQuestions = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(`https://api.japaking.online/api/categories/user-attempt/${level_id}?attemptStatus=${status}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );
                const data = await response.json();
                if (data.success) {
                    setQuestions(data.message.category.questions);
                } else {
                    console.error('Failed to fetch questions:', data.message);
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    console.log("navigate to login due to 401");
                    navigate("Login");
                }
                console.error('Error fetching questions:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuestions();
    }, [category_id, status]);
    // console.log(questions, "questions 500");
    if (isLoading) {

    }
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");


    return (
        <div className='QWantTry'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{getStatus(status)}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container custom-container-announce">

                <div className="row">
                    {questions && questions?.length > 0 ? (
                        <ul className="list-group" style={{ border: "none", padding: 15, backgroundColor: "#fff" }}>
                            {questions.map((item, index) => (
                                <li
                                    key={item.question_id}
                                    className="list-group-item"
                                    style={{ textAlign: "left", border: "none", marginBottom: "10px" }}
                                >
                                    <span>
                                        {index + 1}. {item.question_text}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <>
                            <div className="col-md-8" >
                                <div className='announce_div'>


                                    <h4>
                                        {Translate?.message?.data?.UhohThereAreNoQuestions || " Uh oh! There are no questions of the selected type! Please answer more questions in the quiz and return to check for"}"{getStatus(status)}".
                                    </h4>


                                    <button onClick={() => navigate(-1)} className="JHS-action-button">
                                        {Translate?.message?.data?.returnBackToQuiz || "Return Back to Quiz"}
                                    </button>

                                </div>
                            </div>
                            <div className="col-md-4 announcement-image-container">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/images/announce.jpg`}
                                    alt="No Questions Found"
                                    className="announcement-image"
                                />
                            </div>

                        </>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default QWantTry
